import SimpleParallax, { IParallaxSettings } from "simple-parallax-js";
import Rellax from "rellax";

// Options for the observer (which mutations to observe)
const mutationOptions = { attributes: true, childList: false, subtree: false };

const scaledParallax = (el: HTMLElement, wrapper?: string) => {
  const scale = (el.dataset.scale ?? 1.3) as number;
  const orientation = (el.dataset.orientation ??
    "up") as IParallaxSettings["orientation"];

  new SimpleParallax(el, {
    scale: scale,
    orientation: orientation,
    customWrapper: wrapper,
  });
};

const observeMutation = (el: Element, func: Function) => {
  new MutationObserver(
    (mutationList: MutationRecord[], observer: MutationObserver) => {
      for (const mutation of mutationList) {
        const mutationTarget = mutation.target as HTMLElement;
        if (
          mutation.type === "attributes" &&
          mutation.attributeName == "class" &&
          mutationTarget?.classList.contains("lazyloaded")
        ) {
          setTimeout(() => {
            func();
          }, 200);
          observer.disconnect();
        }
      }
    }
  ).observe(el, mutationOptions);
};

for (const el of document.querySelectorAll(
  ".js-parallax"
) as NodeListOf<HTMLElement>) {
  scaledParallax(el, "section");
}

for (const el of document.querySelectorAll(
  ".js-parallax-items"
) as NodeListOf<HTMLElement>) {
  for (const subEl of el.children) {
    if (subEl instanceof HTMLElement) {
      if (el.children.length > 1) {
        const rellax = new Rellax(subEl);
        observeMutation(subEl, rellax.refresh);
      } else {
        observeMutation(subEl, () => {
          scaledParallax(subEl);
        });
      }
    }
  }
}
